import React from 'react';
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Modal, Space, Tooltip, message } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { BenefitType } from '../../../../types/benefit';
import { BENEFIT } from '../../../../constants/define/translation';
import { deleteBenefitRepository } from '../../../../repository/mytm/benefit/benefitRepository';
import { btnActive } from '../../../../styles';
import { MESSAGE_ERROR } from '../../../../constants/message';
import { CONFIG_CONTAINER_NAME, deleteBlob } from '../../../../utils/azure';

interface ActionsColumnProps {
  record: BenefitType;
  setIsOpenModal: Function;
  setDataRecord: Function;
  onRefresh: () => void;
  total: number;
  handleChangePageActive: Function;
}

export default React.memo((props: ActionsColumnProps) => {
  const { t } = useTranslation(BENEFIT);
  const { record, setIsOpenModal, setDataRecord, onRefresh, handleChangePageActive, total } = props;

  const handleDelete = async () => {
    Modal.confirm({
      title: t('table.popup.title'),
      okText: t('table.popup.okBtn'),
      cancelText: t('table.popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: t('table.popup.delete'),
      onOk() {
        deleteBenefitRepository(record?.id)
          .then(res => {
            deleteBlob(record?.imageUrl, CONFIG_CONTAINER_NAME.UPLOADS).then().catch();
            message.success(t('message.success.deleteBenefit'));
          })
          .catch(() => message.error(MESSAGE_ERROR.M02))
          .finally(() => {
            const numRecord = total - 1;
            if (numRecord && numRecord > 0) {
              onRefresh();
            } else {
              handleChangePageActive(1);
            }
          });
      },
    });
  };

  const handleEdit = () => {
    setIsOpenModal(true);
    setDataRecord(record);
  };

  return (
    <StyledContainer>
      <Space size="small">
        <Tooltip title={t('table.tooltip.edit')}>
          <Button icon={<EditOutlined />} onClick={handleEdit} />
        </Tooltip>
        <Tooltip title={t('table.tooltip.delete')}>
          <Button icon={<DeleteOutlined style={{ color: '#ff4d4f' }} />} onClick={handleDelete} />
        </Tooltip>
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: 0.5rem;
  ${btnActive}
`;
